//
//
//
//
//

export default {
  props: {
    height: {
      type: String,
      default: '300px'
    },
    width: {
      type: String,
      default: '80%'
    }
  }
};